import React, { useState, useCallback } from 'react';
import MTGApp from './components/mtg/MTGApp';
import PokemonApp from './components/pokemon/PokemonApp';
import './App.css';

// Dynamically determine API URL based on current host
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // In production (Cloud Run), the Load Balancer routes /api/* to backend
  // In development, use localhost:5000
  const { protocol, hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:5000`;
  }
  // Production: same origin, no port needed (Load Balancer handles routing)
  return '';
};

const API_URL = getApiUrl();

const TCG_OPTIONS = [
  { id: 'mtg', name: 'Magic: The Gathering' },
  { id: 'pokemon', name: 'Pokémon TCG' }
];

function App() {
  const [currentTCG, setCurrentTCG] = useState('mtg');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const currentTCGData = TCG_OPTIONS.find(t => t.id === currentTCG);

  const handleTCGChange = useCallback((tcgId) => {
    setCurrentTCG(tcgId);
    setDropdownOpen(false);
  }, []);

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <h1 className="app-title">
            <span className="title-icon">◆</span>
            Siah's Codex
            <span className="title-icon">◆</span>
          </h1>
          <div className="tcg-selector">
            <button 
              className="tcg-selector-button"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              aria-expanded={dropdownOpen}
              aria-haspopup="listbox"
            >
              <span className="tcg-name">{currentTCGData.name}</span>
              <span className="tcg-dropdown-arrow">{dropdownOpen ? '▲' : '▼'}</span>
            </button>
            {dropdownOpen && (
              <>
                <div className="tcg-dropdown-backdrop" onClick={() => setDropdownOpen(false)} />
                <ul className="tcg-dropdown" role="listbox">
                  {TCG_OPTIONS.map(tcg => (
                    <li 
                      key={tcg.id}
                      role="option"
                      aria-selected={tcg.id === currentTCG}
                      className={`tcg-option ${tcg.id === currentTCG ? 'active' : ''}`}
                      onClick={() => handleTCGChange(tcg.id)}
                    >
                      {tcg.name}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="app-main">
        {currentTCG === 'mtg' && <MTGApp apiUrl={API_URL} />}
        {currentTCG === 'pokemon' && <PokemonApp apiUrl={API_URL} />}
      </main>

      <footer className="app-footer">
        {currentTCG === 'mtg' && <p>Card data and images © Wizards of the Coast</p>}
        {currentTCG === 'pokemon' && <p>Card data © The Pokémon Company International</p>}
      </footer>
    </div>
  );
}

export default App;
